<template>
    <div>

        <!-- Potientiele dealers -->
        <div class="d-flex align-items-start">
            <h2>
                <i class="fa fa-briefcase"></i>
            </h2>
            <div class="w-100">
                <h2 class="mb-1">
                    Potentiële dealers
                </h2>
            </div>
            <div class="ms-auto mt-2">
                <button v-on:click="updateComponentVisability(componentId)" class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#potentialDealers" aria-expanded="true" aria-controls="potentialDealers">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                </button>
            </div>
        </div>

        <div v-if="loading">
            <div class="loading-spinner"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></div>
        </div>

        <div class="fade-in" :class="{ 'loaded': ! loading }">

            <div class="collapse" :class="{'show': componentIsVisable}" id="potentialDealers">

                <div class="d-flex mt-3 mb-4 align-items-center">
                    <div class="me-3">
                        <label class="form-label mb-0 me-2 text-nowrap">Vanaf</label>
                        <input type="date" class="form-control d-inline-block" style="width:auto" v-model="dateFrom" @change="onDateChange" />
                    </div>
                    <div>
                        <label class="form-label mb-0 me-2 text-nowrap">Tot</label>
                        <input type="date" class="form-control d-inline-block" style="width:auto" v-model="dateTill" @change="onDateChange" />
                    </div>
                </div>

                <div
                    class="messages"
                    v-if="this.potentialDealers.length !== 0"
                >
                    <div
                        v-for="item in this.potentialDealers"
                        class="message"
                    >
                        <div class="content hasBeenRead">
                            <div class="d-flex flex-column-reverse flex-sm-row align-items-baseline">
                                <p class="sender">{{ item.name }}</p>
                                <span class="date ms-sm-auto text-end">
                                    Aantal: {{ item.finished_orders }}<br>
                                    &euro; {{ item.total_price }}
                                </span>
                            </div>
                        </div>
                        <div class="actions">
                            <a :href="'offer?status=&filter=1&order-email='+item.email" target="_blank">
                                <i class="fa fa-external-link"></i>
                            </a>

                            <span v-if="showArchiveButton" v-on:click="convertItem(item)" role="button" title="Toevoegen aan potentiële dealers lijst">
                                <i class="fa fa-plus-circle"></i>
                            </span>

                            <span v-if="showArchiveButton"  v-on:click="archiveItem(item)" role="button">
                                <i class="fa fa-eye-slash"></i>
                            </span>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>

    export default {
        name: 'potential-dealers',
        components: {},
        props: {
            isVisible: {
                type: Boolean,
                default: false
            },
            showArchiveButton: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                potentialDealers: [{
                    key: {
                        name: '',
                        email: '',
                        finished_orders: '',
                        total_price: '',
                    }
                }],

                dateFrom: '',
                dateTill: '',
                componentId: 'potential-dealers-component',
                componentIsVisable: this.isVisible,
                loading: true,
            }
        },
        computed: {},
        watch: {},
        methods: {
            updateComponentVisability(component_id) {
                // Toggle the visibility state
                this.componentIsVisable = !this.componentIsVisable;

                axios.get('api/update-component-visability', {
                    params: {
                        component_id: component_id,
                        is_visable: this.componentIsVisable
                    }
                });

                if(this.componentIsVisable) {
                    this.loading = true;
                    this.getPotentialDealers();
                }
            },
            getPotentialDealers() {
                axios.get('api/potential-dealers', {
                    params: {
                        dateFrom: this.dateFrom,
                        dateTill: this.dateTill,
                    }
                })
                    .then(response => {
                       this.potentialDealers = response.data.potentialDealers;

                        this.dateFrom = response.data.dateFrom;
                        this.dateTill = response.data.dateTill;
                        this.componentId = response.data.componentId;
                        this.loading = false;
                    })
                    .catch(e => {
                        this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                    });
            },
            onDateChange() {
                // If both dates are set and from is after till, swap them for a better UX
                if (this.dateFrom && this.dateTill && this.dateFrom > this.dateTill) {
                    const tmp = this.dateFrom;
                    this.dateFrom = this.dateTill;
                    this.dateTill = tmp;
                }
                this.loading = true;
                this.getPotentialDealers();
            },
            convertItem(item) {

                let parent = this;

                this.$swal({
                    title: "Toevoegen aan potentiële dealers lijst?",
                    text: "De dealer wordt toegevoegd aan de potentiële dealers lijst en uit dit overzicht gearchiveerd.",
                    showCancelButton: true,
                    cancelButtonColor: "#DD3444",
                    confirmButtonColor: "#3EBE00",
                    confirmButtonText: "Ja, toevoegen",
                    cancelButtonText: "Annuleren",
                }).then(
                    function (callBack) {
                        if (callBack.isConfirmed) {

                            parent.loading = true;

                            axios.get('api/potential-dealers-convert-item', {
                                params: {
                                    order_id: item.last_order_id,
                                    email: item.email
                                }
                            })
                            .then(response => {
                                if (response.data && response.data.status === 200) {
                                    parent.getPotentialDealers();
                                } else {
                                    parent.loading = false;
                                    parent.$swal("Er is een fout opgetreden", (response.data && response.data.error) ? response.data.error : "Er is iets mis gegaan bij het toevoegen van de dealer", "error");
                                }
                            })
                            .catch(e => {
                                parent.loading = false;
                                parent.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het toevoegen van de dealer", "error");
                            });
                        }
                    }
                );

            },
            archiveItem(item) {

                let parent = this;

                this.$swal({
                    title: "Potentiële dealer archiveren. Weet je het zeker?",
                    text: "Deze actie kan (momenteel) niet ongedaan gemaakt worden.",
                    showCancelButton: true,
                    cancelButtonColor: "#3EBE00",
                    confirmButtonColor: "#DD3444",
                    confirmButtonText: "Ja, nu archiveren",
                    cancelButtonText: "Annuleren",
                }).then(

                    function (callBack) {
                        if (callBack.isConfirmed) {

                            parent.loading = true;

                            axios.get('api/potential-dealers-archive-item', {
                                params: {
                                    email: item.email
                                }
                            })
                            .then(response => {
                                parent.getPotentialDealers();
                            })
                            .catch(e => {
                                this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het archiveren van de dealer", "error");
                            });
                        }
                    }
                );

            },
        },
        mounted() {

            console.log(this.showArchiveButton);

            if(this.isVisible) {
                this.getPotentialDealers();
            } else {
                this.loading = false;
            }
        },
        created() {
        },

    }
</script>
